import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PlaceTypeProvider } from '../_context/PlaceTypeContext'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import AddNewButton from './AddNewButton'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import LevelsLoader from '../_load/LevelsLoader'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from './PageHeader'
import PlacesLoader from './_load/PlacesLoader'
import PlacesTable from './table/PlacesTable'
import SendFormGuideBar from '../sendForm/SendFormGuideBar'
import SendFormHandler from '../sendForm/_form/SendFormHandler'
import SendFormModal from '../sendForm/SendFormModal'
import Separator from '../../../components/helpers/Separator'

const PlacesListPage = ({ type }) => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PlaceTypeProvider value={type}>
        <Container>
          <LevelsLoader>
            <SendFormGuideBar />

            <FilterHandler tempStorageNamespace={type} initialState={{}}>
              <PageHeader />
              <ControlBar />

              <MultiSelectHandler>
                <SendFormHandler>
                  <PlacesLoader uncontrolledChildren={<MultiRowsActions />}>
                    <PlacesTable />
                  </PlacesLoader>

                  <SendFormModal />
                </SendFormHandler>
              </MultiSelectHandler>
            </FilterHandler>
          </LevelsLoader>

          <AddNewButton />
          <Separator weight={90} />
        </Container>
      </PlaceTypeProvider>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default PlacesListPage
